"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var withContext_1 = require("../../utils/hoc/withContext");
var AutocompleteWithinContext_1 = require("./AutocompleteWithinContext");
/**
 * The `Autocomplete` component is an extension of the `Input` component that features
 * input suggestions. The suggestion list will be shown below the input while it is focused.
 *
 * This component - expect for the `onChange` callback - will behave just as the `Input` while no
 * suggestion list is specified. All props will be passed directly to the `Input` component.
 * The `onChange` callback will pass the input value or currently selected suggestion instead of a change event.
 * Duplicate entries of the suggestion list will be filtered.
 *
 * This component uses the [react-autocomplete](https://github.com/reactjs/react-autocomplete) library internally.
 * All supported `react-autocomplete` props can be used at your own risk. We might change the internal
 * implementation in future versions of this library.
 *
 * ---
 *
 * **Caveats**:<br>
 *
 * <img src="firefox.svg" alt="drawing" width="30"/>
 *
 * When using the Autocomplete component in Firefox with a mouse,
 * the focus of the element will be lost after selecting the value from the list, and therefore the `onBlur` callback will not be called.
 * This behavior on Firefox seems to be an unconfirmed bug. However, if you need the `onBlur` callback to happen on Firefox when using a mouse,
 * the following code snippet should fix this issue for you:
 * ```
 * initialState = { value: '' };
 *
  <Autocomplete
    className="your-desired-class-name"
    value={state.value}
    onChange={value => {
      document
        .getElementsByClassName('your-desired-class-name')[0]
        .getElementsByTagName('input')[0]
        .focus();
      return setState({ value })
    }}
    suggestions={['Suggestion 1', 'Suggestion 2', 'Suggestion 3']}
  />
 * ```
 */
exports.Autocomplete = withContext_1.withErgoElementsContext('Autocomplete', AutocompleteWithinContext_1.AutocompleteWithinContext);
exports.default = exports.Autocomplete;
__export(require("./AutocompleteWithinContext"));
//# sourceMappingURL=Autocomplete.js.map